import { Box, Breadcrumbs, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { app_title } from './../../config'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'

export default function EligibilityCriteria() {
	const { t } = useTranslation()
	const theme = useTheme()

	const criteria = [
		{ criteria: "Fibe (Early salary)", age: "21-55", employment: "Salaried", income: "20000", minLoan: "8000", maxLoan: "400000", cibil: "700+", journey: "App" },
		{ criteria: "Smartcoin", age: "24-45", employment: "Both", income: "20000", minLoan: "3000", maxLoan: "100000", cibil: "680+", journey: "App" },
		{ criteria: "Muthoot", age: ">24", employment: "Both", income: "NA", minLoan: "2000", maxLoan: "Upto Gold value", cibil: "", journey: "Web/App" },
		{ criteria: "prefr", age: "22-55", employment: "Salaried/Self Employed", income: "20000", minLoan: "25000", maxLoan: "300                        000", cibil: "680+", journey: "App" },
		{ criteria: "Zype", age: "Min-21 yrs , Max-50 Yrs", employment: "Salaried /NTC Allowed", income: "20000", minLoan: "1,000", maxLoan: "500,000", cibil: "720+", journey: "Web/App" },
		{ criteria: "Incred", age: "Salaried - 21 -55       SE 23-60 ( GST YES)", employment: "Salaried/Self Employed", income: "Salaried: 20000, Self employed: 25000", minLoan: "25,000", maxLoan: "1,000,000", cibil: "625+", journey: "App" },
		{ criteria: "ABCDL", age: "20+", employment: "salaried", income: "35000", minLoan: "50000", maxLoan: "1,000,000", cibil: "750+", journey: "Web/App" },
		{ criteria: "Ram Fincorp", age: "18-58", employment: "Salaried", income: "20000", minLoan: "1000", maxLoan: "100,000", cibil: "680+", journey: "Web/App" },
		{ criteria: "SMFG(Fullerton)", age: "21-65", employment: "Salaried/Self Employed", income: "25000", minLoan: "50000", maxLoan: "2,500,000", cibil: "750+", journey: "Web/App" },
		{ criteria: "Niro Money", age: "21-55", employment: "Salaried/Self Employed", income: "25000", minLoan: "50000", maxLoan: "500,000", cibil: "650+", journey: "Web/App" },
		{ criteria: "ICICI Bank", age: "Salaried 23-58  /  Self Employed 28-65", employment: "Salaried/Self Employed", income: "Salaried: 30000, Self employed: 15 lakh turnover", minLoan: "50000", maxLoan: "5000000", cibil: "750+", journey: "Web/App" },
		{ criteria: "Moneytap", age: "23-55", employment: "Salaried/Self Employed", income: "30000", minLoan: "3000", maxLoan: "500000", cibil: "700+", journey: "Web/App" },
		{ criteria: "Tata Capital", age: "21-58", employment: "Salaried/Self Employed", income: "18000", minLoan: "50000", maxLoan: "5000000", cibil: "725+", journey: "Web/App" },
		{ criteria: "Lendingplate", age: "21+", employment: "Salaried", income: "20000", minLoan: "5000", maxLoan: "250000", cibil: "680+", journey: "Web/App" },
		{ criteria: "True Balance", age: "18-58", employment: "Salaried", income: "18000", minLoan: "1000", maxLoan: "200000", cibil: "680+", journey: "Web/App" },
		{ criteria: "IndusInd", age: "21-60", employment: "Salaried/Self Employed", income: "25000", minLoan: "30000", maxLoan: "5000000", cibil: "700+", journey: "Web/App" },
		{ criteria: "CashE", age: "23-58", employment: "Salaried/Self Employed", income: "18000", minLoan: "45000", maxLoan: "300000", cibil: "680+", journey: "Web/App" },
		{ criteria: "Fakapay", age: "18+", employment: "Salaried", income: "18000", minLoan: "5000", maxLoan: "200000", cibil: "680+", journey: "Web/App" },
		{ criteria: "Rupee 112", age: "25+50", employment: "Salaried", income: "50000", minLoan: "5000", maxLoan: "100000", cibil: "680+", journey: "Web/App" },
		{ criteria: "Bharat Loan", age: "25+55", employment: "Salaried", income: "30000", minLoan: "", maxLoan: "100000", cibil: "680+", journey: "Web/App" },
		{ criteria: "Insta Money", age: "21-45", employment: "Salaried/Self Employed", income: "18000", minLoan: "5000", maxLoan: "25000", cibil: "680+", journey: "Web/App" },
		{ criteria: "MoneyView", age: "21-57", employment: "Salaried/Self Employed", income: "18000", minLoan: "5000", maxLoan: "1000000", cibil: "680+", journey: "Web/App" },
		{ criteria: "Branch", age: "18-58", employment: "Salaried/Self Employed", income: "Salaried: 15000, Self employed: 18000", minLoan: "750", maxLoan: "50000", cibil: "650+", journey: "App" },
	]

	return (
		<>
			<Helmet>
				<title>Partner - Eligibility Criteria {app_title && `| ${app_title}`}</title>
			</Helmet>
			<Box
				component="div"
				sx={{
					p: { sm: 0.5, md: 1 },
					width: "100%",
					maxWidth: "1600px",
					margin: "0 auto",
					overflowX: "hidden",
				}}
			>
				<Box mb={4}>
					<Typography
						variant="h5"
						fontWeight="bold"
						color="secondary.main"
						mb={1}
					>
						{t("Eligibility Criteria")}
					</Typography>
					<Breadcrumbs>
						<Link style={{ color: theme.palette.primary.main, textDecoration: "none" }} to="/partner">Dashboard</Link>
						<Link style={{ color: theme.palette.primary.main, textDecoration: "none" }} to="/partner/training-material">Training Material</Link>
						<Typography>Eligibility Criteria</Typography>
					</Breadcrumbs>
				</Box>

				<TableContainer>
					<Table>
						<TableHead>
							<TableRow sx={{ backgroundColor: '#FAFAFA' }}>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Criteria</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Age</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Salaried/Selfemployed</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Monthly net income</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Min loan</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Max loan</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Cibil</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Lender Journey</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{criteria.map((row, index) => (
								<TableRow key={index} >
									<TableCell sx={{ border: '1px solid #ddd', fontWeight: 'bold', padding: '8px', textAlign: 'center' }}>{row.criteria}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.age}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.employment}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.income}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.minLoan}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.maxLoan}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.cibil}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.journey}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</>
	)
}
